export const REQUEST_SERVICE_FORM_ATTRIBUTES = {
  PREF_DATE_TYPE: {
    ASAP: 'ASAP',
    CUSTOM: 'CUSTOM'
  }
};
export const TAB_INDEX = {
  ASAP: 0,
  CUSTOM: 1
}

export const TOAST_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
}